<mat-expansion-panel
	[togglePosition]="'before'"
	[expanded]="false"
	class="export-action-panel level-2 pl-4"
	*ngIf="CartUtils.extractGroupItems(group) as items"
>
	<mat-expansion-panel-header *localVar="items?.[0] as firstItem">
		<div class="mt-1 action-details level-2">
			<div class="export-title level-2">
				<mat-icon
					*localVar="items | transformObject : ExportDownloadUtils.findItemByStatus : TaskStatus.Failed as isFailed"
					class="status-icon"
					[ngClass]="{ success: !isFailed, failure: isFailed }"
				>
					{{ isFailed ? 'clear' : 'check' }}
				</mat-icon>

				<span class="name">
					{{ firstItem.metadata?.listingName || group.name | getLocale : firstItem.locale?.listing?.name }}
				</span>
				<span
					class="sizes"
					i18n="Export Sizes Count@@exportDownloadSizesCount"
					*ngIf="items?.length as sizes">
					({{ sizes }} {sizes, plural, =1 {size} other {sizes}})
				</span>
				<div>
					<mat-chip-list class="items-tags">
						<mat-chip
							*ngFor="let format of (items | transformObject : ExportDownloadUtils.getGroupFormats)"
							class="tag-item"
						>
							<span>{{ EXPORT_TYPE_LABELS[format] | titlecase }}</span>
						</mat-chip>
					</mat-chip-list>
				</div>
			</div>
			<button
				color="primary"
				class="download-button"
				(click)="$event.stopImmediatePropagation();
					firstItem.type === CartItemType.VIDEO
						? downloadItem.emit({ cartItem: firstItem })
						: downloadByPackageId.emit(firstItem)"
			>
				<mat-icon inline>download</mat-icon>
			</button>
		</div>
	</mat-expansion-panel-header>
	<div class="export-destination-details no-border">
		<div class="action-details" *ngFor="let group of combinedGroups">
			<ng-container *ngIf="group.parentType === 'package'">
				<app-export-download-item-row
					*ngFor="let item of (group.items | arrayOrDefault)"
					[item]="item"
					(retryTasks)="retryTasks.emit()"
					(downloadItem)="downloadItem.emit($event)"
				></app-export-download-item-row>
			</ng-container>

			<ng-container *ngIf="group.parentType === 'group'">
				<app-export-download-subgroup-row
					[subgroup]="group"
					(retryTasks)="retryTasks.emit()"
					(downloadItem)="downloadItem.emit($event)"
					(downloadByGroupId)="downloadByGroupId.emit($event)"
					(downloadByPackageId)="downloadByPackageId.emit($event)"
				></app-export-download-subgroup-row>
			</ng-container>
		</div>
	</div>
</mat-expansion-panel>
